/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ActionType;

(function (ActionType) {
  ActionType["UPLOADED_INSURANCE_DOCUMENT"] = "uploaded_insurance_document";
  ActionType["DELETE_INSURANCE_DOCUMENT"] = "delete_insurance_document";
  ActionType["QUOTED_FOR_INSURANCE"] = "quoted_for_insurance";
  ActionType["PURCHASED_INSURANCE"] = "purchased_insurance";
  ActionType["CANCELED_VALIDATION"] = "canceled_validation";
  ActionType["ACCOUNT_DEACTIVATED"] = "account_deactivated";
  ActionType["ACCOUNT_REACTIVATE"] = "account_reactivate";
  ActionType["ADDED_AGENT_INPUT"] = "added_agent_input";
  ActionType["OVERWRITE_VALIDATION_STATUS"] = "overwrite_validation_status";
  ActionType["INVITED_FOR_VALIDATION"] = "invited_for_validation";
  ActionType["SENT_WHATSAPP_MESSAGE"] = "sent_whatsapp_message";
  ActionType["START_VALIDATION"] = "start_validation";
  ActionType["VALIDATION_STATUS_UPDATE"] = "validation_status_update";
  ActionType["REQUIREMENT_CHANGED"] = "requirement_changed";
  ActionType["VALIDATION_RESULT_GENERATED"] = "validation_result_generated";
  ActionType["CANCELED_PREVIOUS_INSURANCE"] = "canceled_previous_insurance";
})(ActionType || (ActionType = {}));